import { SecurityIssuesTypes } from 'types/embedded/securityIssues';

export const SECURITY_ISSUES = {
  [SecurityIssuesTypes.NoWhitelist]: {
    title: 'Whitelist не настроен',
    color: '#ED6C02',
  },
  [SecurityIssuesTypes.Open]: {
    title: 'Доступ всем IP',
    color: '#D32F2F',
  },
  [SecurityIssuesTypes.NoProblem]: {
    title: 'Нет проблем',
    color: '#2E7D32',
  },
};

export const SECURITY_ISSUES_ROWS_BG = {
  [SecurityIssuesTypes.NoProblem]: '#FFF',
  [SecurityIssuesTypes.Open]: '#FEEBEE',
  [SecurityIssuesTypes.NoWhitelist]: '#FFF3E0',
};

export const SECURITY_ISSUES_SELECT_ITEMS = [
  { id: SecurityIssuesTypes.NoWhitelist, name: 'Whitelist не настроен' },
  { id: SecurityIssuesTypes.Open, name: 'Доступ всем IP' },
  { id: SecurityIssuesTypes.NoProblem, name: 'Нет проблем' },
];
